const clientThemes = {
  xp: { logo: '/assets/images/logos/xp_client_logo.svg', baseColor: '#232D28', logoStyle: { width: 135, height: 'auto' } },
  avenue: { logo: '/assets/images/logos/avenue_client_logo.svg', baseColor: '#232D28', logoStyle: { width: 115, height: 'auto' }},
}

export const getClientLogoFile = () => {
  return clientThemes[process.env.REACT_APP_CLIENT]?.logo
}

export const getClientBaseColor = () => {
  return clientThemes[process.env.REACT_APP_CLIENT]?.baseColor || '#232D28'
}

export const getClientLogoStyle = () => {
  return clientThemes[process.env.REACT_APP_CLIENT]?.logoStyle || { width: 135, height: 'auto' }
}
